import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { api, API_BASE } from '../../api/client';

interface SocialLinks {
  id: number;
  instagram: string;
  facebook: string;
  telegram: string;
}

const EMPTY: Omit<SocialLinks, 'id'> = { instagram: '', facebook: '', telegram: '' };

export default function AdminSocialLinksPage() {
  const [socialLinks, setSocialLinks] = useState<SocialLinks | null>(null);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const load = async () => {
    const r = await axios.get(`${API_BASE}/social-links`);
    if (r.data.length > 0) {
      setSocialLinks(r.data[0]);
      setForm(r.data[0]);
    }
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    try {
      if (socialLinks) {
        await api.put(`/social-links/${socialLinks.id}`, form);
      } else {
        await api.post('/social-links', form);
      }
      await load();
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Управление социальными сетями</h2>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}>
          {socialLinks ? '✏️ Редактировать ссылки на соцсети' : '➕ Добавить ссылки на соцсети'}
        </h3>

        <form onSubmit={handleSubmit} style={styles.form}>

          <div style={styles.field}>
            <label style={styles.label}>📸 Instagram</label>
            <input
              style={styles.input}
              placeholder="https://instagram.com/yourprofile"
              value={form.instagram}
              onChange={e => setForm({ ...form, instagram: e.target.value })}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>📘 Facebook</label>
            <input
              style={styles.input}
              placeholder="https://facebook.com/yourpage"
              value={form.facebook}
              onChange={e => setForm({ ...form, facebook: e.target.value })}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>✈️ Telegram</label>
            <input
              style={styles.input}
              placeholder="https://t.me/yourchannel"
              value={form.telegram}
              onChange={e => setForm({ ...form, telegram: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <button style={styles.btn} type="submit" disabled={saving}>
              {saving ? 'Сохранение...' : '💾 Сохранить'}
            </button>
            {saved && <span style={styles.savedMsg}>✅ Сохранено!</span>}
          </div>
        </form>
      </div>

      {/* Превью */}
      {socialLinks && (
        <div style={styles.preview}>
          <h3 style={styles.previewTitle}>Текущие ссылки на сайте</h3>
          <div style={styles.previewGrid}>
            <div><strong>Instagram:</strong> {socialLinks.instagram || 'Не указано'}</div>
            <div><strong>Facebook:</strong> {socialLinks.facebook || 'Не указано'}</div>
            <div><strong>Telegram:</strong> {socialLinks.telegram || 'Не указано'}</div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { padding: 'clamp(16px, 4vw, 32px)', maxWidth: 700, margin: '0 auto' },
  title: { color: '#1a3a6b', fontSize: 'clamp(1.3rem, 3vw, 1.6rem)', marginBottom: 'clamp(16px, 3vw, 24px)' },
  card: {
    background: '#fff', borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    marginBottom: 20, overflow: 'hidden',
  },
  cardTitle: {
    color: '#1a3a6b', fontSize: 'clamp(0.9rem, 2vw, 1rem)',
    padding: '16px 20px', borderBottom: '1px solid #f0f4fb',
  },
  form: { display: 'flex', flexDirection: 'column', gap: 16, padding: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontWeight: 600, color: '#444', fontSize: '0.9rem' },
  input: {
    padding: '10px 14px', borderRadius: 8,
    border: '1px solid #dde3ef', fontSize: '0.95rem', outline: 'none', width: '100%',
  },
  btn: {
    padding: '10px 24px', background: '#1a3a6b',
    color: '#fff', border: 'none', borderRadius: 8,
    fontWeight: 600, cursor: 'pointer',
  },
  savedMsg: { color: '#27ae60', fontWeight: 600, fontSize: '0.9rem' },
  preview: {
    background: '#f0f4fb', borderRadius: 10,
    padding: 'clamp(16px, 3vw, 20px) clamp(18px, 4vw, 24px)',
  },
  previewTitle: { color: '#1a3a6b', fontSize: '0.95rem', marginBottom: 14 },
  previewGrid: { display: 'flex', flexDirection: 'column', gap: 8, fontSize: '0.9rem', color: '#444', wordBreak: 'break-word' },
};
